<template>
    <div class="nav-content">
        <div style="margin-top: 40px">
            <Breadcrumb separator=">">
                <BreadcrumbItem @click.native="back()" class="content-item">首页</BreadcrumbItem>
                <BreadcrumbItem style="cursor: auto;" class="content-item">
                    站内搜索
                </BreadcrumbItem>
                <BreadcrumbItem class="content-item">搜索结果</BreadcrumbItem>
            </Breadcrumb>
        </div>
        <div style="width: 100%; text-align: center; margin-top: 12px;">
            <Input v-model="searchText" @on-keyup.enter="search" placeholder="请输入搜索内容" style="width: 300px" />
            <Button @click="search" type="primary">搜索</Button>
        </div>
        <div class="content">
            <div class="content-item" @click="jump(item)" v-for="(item, index) in list" :key="index">
                <div class="left">
                    <span>·&nbsp;</span>
                    <span>{{item.title}}</span>
                </div>
                <div class="right">
                    <span>{{item.deployTime}}</span>
                </div>
            </div>
            <div class="page">
                <Page :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 50, 100]" show-total show-sizer
                    show-elevator @on-change="handlePageChange" @on-page-size-change="changePageSize" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "detail",
    components: {},
    data() {
        return {
            txt: "",
            list: [],
            title: "",
            name: "",
            total: 0,
            state: true,
            pageNum: 1,
            pageSize: 20,
            searchText: "",
            channels: [],
            navigation: [],
        };
    },
    watch: {
        //监听当前路由并更新对应数据
        $route: {
            handler: function (to, from) {
                let qwe = this.$route.query;
                this.searchText = qwe.searchText;
                this.search();
            },
            deep: true,
        },
    },
    //保证刷新的时候（此时路由没有变化）可以实现一边基本操作
    mounted() {
        this.searchText = this.$route.query.searchText;
        GMS.$http
            .get("/home/getNavigation")
            .then((res) => {
                if (res.status == 200) {
                    res.data.forEach((item) => {
                        if (item.cmsId) {
                            this.channels.push(item.cmsId);
                            this.navigation.push(item);
                        }
                        this.search();
                    });
                }
            })
            .catch((error) => {
                this.$Message.error("获取数据异常，请联系管理员");
            });
    },
    methods: {
        jump(res) {
            const channel = this.navigation.find((item) => item.cmsId == res.channelGuid);
            const channelTitle = channel.title;
            switch (channelTitle) {
                case "工作动态":
                    this.jumpDetail(res, "工作动态");
                    break;
                case "通知公告":
                    this.jumpDetail(res, "通知公告");
                    break;
                case "采购意向公开":
                    this.jumpDetail(res, "信息公开");
                    break;
                case "自购公示":
                    this.jumpDetail(res, "信息公开");
                    break;
                case "政府采购公告-采购公告":
                    this.jumpZfcggg(res);
                    break;
                case "政府采购公告-结果公告":
                    this.jumpZfcggg(res);
                    break;
                case "政府采购公告-更正公告":
                    this.jumpZfcggg(res);
                    break;
                case "学校统一采购公告-采购公告":
                    this.jumpZfcggg(res);
                    break;
                case "学校统一采购公告-结果公告":
                    this.jumpZfcggg(res);
                    break;
                case "学校统一采购公告-更正公告":
                    this.jumpZfcggg(res);
                    break;
                case "学校统一采购公告-更正公告":
                    this.jumpZfcggg(res);
                    break;
                default:
                    this.jumpDetail(res);
                    break;
            }
        },
        jumpZfcggg(res) {
            let Modal = true;
            GMS.$http
                .get(`/portal/cms/content?guid=` + res.guid, {})
                .then((value) => {
                    console.log("获取详情内容返回信息", value);
                    if (value.status == 200) {
                        const text = value.data.datas.data.text;
                        // Check if text contains "公告挂网地址" and has a URL
                        const urlMatch = text.match(/公告挂网地址：<a href="([^"]*)"[^>]*>([^<]*)<\/a>/i);

                        if (urlMatch && urlMatch[1]) {
                            // Found a URL after "公告挂网地址", redirect to it
                            window.open(urlMatch[1], "_blank");
                        } else {
                            // No matching URL found, throw error which will trigger .catch()
                            throw new Error("No valid announcement URL found in content");
                        }
                    }
                })
                .catch((error) => {
                    this.jumpDetail(res);
                });
        },
        jumpDetail(res, title) {
            let Modal = true;
            GMS.$http
                .post(`/portal/cms/checkPrivileges?guid=` + res.guid, {
                    userName: JSON.parse(sessionStorage.getItem("person")),
                })
                .then((value) => {
                    if (value.status == 200) {
                        Modal = value.data;
                        if (!Modal) {
                            GMS.vbus.$emit("Modal-Show");
                            return;
                        } else {
                            this.$router.push({
                                path: "/home/detail",
                                query: {
                                    title: title || res.title,
                                    name: "",
                                    guid: res.guid,
                                    total: res.title,
                                },
                            });
                        }
                    }
                });
        },
        handlePageChange(pageNum) {
            this.pageNum = pageNum;
            this.search();
        },
        changePageSize(pageSize) {
            this.pageSize = pageSize;
            this.search();
        },
        search() {
            let pram = {
                channels: JSON.stringify(this.channels),
                filter: null,
                pageInfo: JSON.stringify({
                    pageNum: this.pageNum,
                    pageSize: this.pageSize,
                }),
            };
            if (this.searchText) {
                pram.filter = JSON.stringify({ deployed: 1, searchKeys: this.searchText });
            } else {
                pram.filter = JSON.stringify({ deployed: 1 });
            }
            GMS.$http
                .post("/portal/cms/view/contents", pram, {})
                .then((res) => {
                    if (res.status == 200) {
                        this.list = res.data.bean;
                        this.total = res.data.total;
                    }
                })
                .catch((error) => {
                    this.$Message.error("获取数据异常，请联系管理员");
                });
        },
        back() {
            if (this.$route.path.startsWith("/home")) {
                // 当前路由是以 /home 开头的
                this.$router.push("/home");
            } else if (this.$route.path.startsWith("/Portal")) {
                // 当前路由是以 /Portal 开头的
                this.$router.push("/Portal");
            }
        },
    },
};
</script>

<style scoped lang="less">
.demo-breadcrumb-separator {
    padding-left: 16px;
    line-height: 42px;
    color: #7f7f7f;
    font-size: 18px;
    font-weight: 400;
}

.iten {
    margin-top: 40px;
    text-align: left;
}

.itn {
    margin-top: 63px;
    margin-bottom: 24px;
}

.icons {
    float: right;
    width: 64px;
    height: 32px;
    text-align: center;
    cursor: pointer;
    background-color: #006ac0;
    border-radius: 4px;
    line-height: 32px;
    color: #ffffff;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px;
}
.content-item {
    cursor: pointer;
    font-size: 18px;
    font-weight: 600;
    color: #424242;
    line-height: 42px;
    font-family: PingFangSC-S0pxibold;
}
ul {
    li {
        float: left;
        list-style: none;
        color: #424242;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 15px;
        line-height: 62px;
        margin-right: 32px;
    }
}
.nav-content {
    width: 1200px;
    margin: 0 auto;
}
.content {
    padding: 30px 0;
    .content-item {
        display: flex;
        justify-content: space-between;
        font-weight: 600;
        font-size: 16px;
        color: #424242;
    }
    .content-item:nth-child(5n) {
        padding-bottom: 15px;
        border-bottom: 1px dashed #dcdee2;
        margin-bottom: 15px;
    }
    .page {
        text-align: center;
        margin-top: 30px;
    }
}
@media screen and (max-width: 1500px) {
    .nav-content {
        width: 1200px;
    }
}
@media screen and (min-width: 1500px) and (max-width: 1800px) {
    .nav-content {
        width: 1400px;
    }
}
@media screen and (min-width: 1800px) {
    .nav-content {
        width: 1600px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/inside/search-result.vue